export const QA_NAME_TABLE_HEADER_CELL_CONTEXT = 'table_header_cell'
